import TimePicker from '@kopapro/components/commons/time-picker-dropdown/timePicker';
import { withTranslation } from 'react-i18next';

export default withTranslation()(TimePicker);

